(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-gallery]');
      const target = gallery?.querySelector('[data-gallery-main]');
      if (!target) return;
      const image = button.dataset.image;
      const alt = button.dataset.alt || '';
      target.src = image;
      target.alt = alt;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });

  const setConditionalField = (container, selector, active) => {
    const field = container.querySelector(selector);
    if (!field) return;
    field.hidden = !active;
    field.querySelectorAll('[data-conditional-input]').forEach((input) => {
      input.disabled = !active;
      input.required = active;
      if (!active) input.value = '';
    });
  };

  document.querySelectorAll('[data-recognition-customizer]').forEach((customizer) => {
    const updateBackground = () => {
      const selected = customizer.querySelector('[data-background-choice]:checked');
      const uploadSelected = selected?.dataset.backgroundChoice === 'upload';
      setConditionalField(customizer, '[data-background-upload]', uploadSelected);
      customizer.querySelectorAll('[data-background-choice]').forEach((input) => input.setAttribute('aria-expanded', String(uploadSelected && input === selected)));
    };

    const updateName = () => {
      const selected = customizer.querySelector('[data-name-choice]:checked');
      setConditionalField(customizer, '[data-name-text]', selected?.dataset.nameChoice === 'text');
      setConditionalField(customizer, '[data-name-upload]', selected?.dataset.nameChoice === 'upload');
      customizer.querySelectorAll('[data-name-choice]').forEach((input) => input.setAttribute('aria-expanded', String(input === selected)));
    };

    customizer.querySelectorAll('[data-background-choice]').forEach((input) => input.addEventListener('change', updateBackground));
    customizer.querySelectorAll('[data-name-choice]').forEach((input) => input.addEventListener('change', updateName));
    updateBackground();
    updateName();
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantsElement = form.querySelector('[data-product-variants]');
    if (!variantsElement) return;
    const variants = JSON.parse(variantsElement.textContent);
    const idInput = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[type="submit"]');
    const price = document.querySelector('[data-product-price]');
    const optionInputs = [...form.querySelectorAll('[data-option-position]')];

    const updateVariant = () => {
      const selected = [];
      optionInputs.forEach((input) => {
        if (input.checked || input.tagName === 'SELECT') selected[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = window.themeStrings?.unavailable || 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? (window.themeStrings?.addToCart || 'Add to cart') : (window.themeStrings?.soldOut || 'Sold out');
      if (price && window.Shopify?.formatMoney) price.textContent = window.Shopify.formatMoney(variant.price);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });
})();
